// extracted by css-extract-rspack-plugin
export default {"cls1":"CiterightPreprintReport-cls1_J84","cls2":"CiterightPreprintReport-cls2_Ms4 CiterightPreprintReport-cls1_J84"};